import Container from "@/components/common/Container";
import Modal from "@/components/common/Modal";
import Image from "next/image";
import { useState } from "react";

const CHOOSE_US_FOR_SERVICES_DATA = [
  { list: "Hire with Flexibility" },
  { list: "Streamlined Market Launch" },
  { list: "Seasoned Developers" },
  { list: "Detailed Reports" },
  { list: "Multi-Domain Expertise" },
];

const ChooseUs = (data) => {
  const { title, descriptions } = data.chooseAsForServices;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Container large className="bg-primary-black py-20 md:pt-20 md:pb-0 xl:pt-40 xl:pb-14">
        <div className="flex flex-col lg:flex-row relative">
          <div className="lg:w-1/2">
            <h2 className="text-white text-4xl md:text-3xl lg:text-6xl font-medium mb-10 lg:mb-0 w-11/12 md:w-3/5 lg:w-10/12 leading-tight lg:leading-tight">
              <span>{title}</span>
            </h2>
          </div>
          <div className="lg:w-1/2">
            <p className="text-base md:text-sm lg:text-base font-normal text-justify text-white mb-0 pb-10 lg:pb-20">
              <span dangerouslySetInnerHTML={{ __html: descriptions }}></span>
            </p>
            <div className="flex flex-col md:flex-row flex-wrap">
              {CHOOSE_US_FOR_SERVICES_DATA.map((value) => (
                <div
                  key={value.list}
                  className="md:w-1/2 flex items-start pb-8 md:pb-5 lg:pb-8"
                >
                  <div className="md:w-4 lg:w-auto">
                    <Image
                      alt="Round"
                      height={24}
                      src="/assets/common/round-true.webp"
                      width={24}
                    />
                  </div>
                  <p className="mb-0 text-normal text-white text-base lg:text-xl ml-6 md:ml-3 lg:ml-6 md:leading-tight lg:leading-normal">
                    <span>{value.list}</span>
                  </p>
                </div>
              ))}
            </div>
            <div className="pt-2 md:pt-5 lg:pt-12">
              <button
                onClick={openModal}
                className="py-4 px-10 md:py-2 md:px-5 lg:py-4 lg:px-10 bg-primary-yellow hover:bg-transparent border border-solid border-primary-yellow rounded-lg md:rounded lg:rounded-lg text-base md:text-sm lg:text-lg font-medium outline-none text-white hover:text-primary-yellow transition-all duration-500 ease-out hover:ease-in"
              >
                <span>Book a 30 min Call Now</span>
              </button>
            </div>
          </div>
        </div>
      </Container>
      <Modal isOpen={modalOpen} onClose={closeModal} />
    </>
  );
};
export default ChooseUs;
